// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"253":"9bea01ef","440":"fa42ccdd","581":"c0dd8fc9"}[chunkId] + ".js";
};